import React, {useState} from "react";
import {
    courierStatuses,
    deliveryStatuses,
    courierStatusColors
} from "../../../../constants/constants";
import moment from "moment";
import {CourierIcon} from "components/_defaultComponents/CourierIcon/CourierIcon";
import {DownOutlined, UpOutlined} from "@ant-design/icons";
import {
    PopupContainer,
    Header,
    TitleContainer,
    Icon,
    Title,
    Section,
    CollapsibleHeader,
    CollapsibleTitle,
    CollapsibleIcon,
    CollapsibleContent,
    List,
    ListItem,
    Status,
    NoData
} from "../style/CourierPopup.style";
import {useStore} from "hooks/useStore";

const CourierPopup = ({courier, details, isLoading}) => {
    const [isCourierInfoOpen, setIsCourierInfoOpen] = useState(true);
    const [isOrderInfoOpen, setIsOrderInfoOpen] = useState(false);
    const stores = useStore();

    const getStatusColor = status => {
        return courierStatusColors[status] || "#d9d9d9";
    };

    const getStatusName = status => {
        const found = courierStatuses.find(s => s.value === status);
        return found ? found.name : status;
    };

    const getDeliveryStateName = state => {
        if (!state) return "Cevap Bekleniyor";
        const found = deliveryStatuses.find(s => s.value === state);
        return found ? found.name : state;
    };

    const mergedCourier = {...(courier || {}), ...(details || {})};
    const courierName =
        mergedCourier?.courier?.fullname ||
        mergedCourier?.fullname ||
        courier?.courier?.fullname ||
        courier?.fullname ||
        courier?.courierName ||
        "Bilinmeyen Kurye";
    const phone =
        mergedCourier?.courier?.cellPhone ||
        mergedCourier?.cellPhone ||
        mergedCourier?.phone ||
        courier?.courier?.cellPhone ||
        courier?.cellPhone ||
        "";
    const status = mergedCourier?.status || courier?.status || "";
    const poolShift = mergedCourier?.poolShift || courier?.poolShift;
    const delivery = courier?.delivery || mergedCourier?.delivery;
    const serverTime = mergedCourier?.serverTime || courier?.serverTime;
    const poolRegionName = mergedCourier?.poolShift?.name || "";

    return (
        <PopupContainer>
            <Header>
                <TitleContainer>
                    <Icon>
                        <CourierIcon courierType="motorCourier" />
                    </Icon>
                    <Title>{courierName}</Title>
                </TitleContainer>
            </Header>

            <Section>
                <CollapsibleHeader onClick={() => setIsCourierInfoOpen(!isCourierInfoOpen)}>
                    <CollapsibleTitle>Kurye Bilgileri</CollapsibleTitle>
                    <CollapsibleIcon>
                        {isCourierInfoOpen ? <UpOutlined /> : <DownOutlined />}
                    </CollapsibleIcon>
                </CollapsibleHeader>
                <CollapsibleContent isOpen={isCourierInfoOpen}>
                    <List>
                        {isLoading && <ListItem>Yükleniyor...</ListItem>}
                        {phone && <ListItem>{phone}</ListItem>}
                        {delivery && (
                            <ListItem>{getDeliveryStateName(delivery?.deliveryState)}</ListItem>
                        )}
                        {stores.meStore.checkRole("notVisibleForCompanyUser") && poolRegionName && (
                            <ListItem>Havuz Bölgesi: {poolRegionName}</ListItem>
                        )}
                        <ListItem>
                            Durum:{" "}
                            <Status style={{color: getStatusColor(status)}}>
                                {getStatusName(status)}
                            </Status>
                        </ListItem>
                        {poolShift?.shiftStart && (
                            <ListItem>
                                Vardiya: {moment(poolShift?.shiftStart).format("HH:mm")} -{" "}
                                {moment(poolShift?.shiftEnd).format("HH:mm")}
                            </ListItem>
                        )}
                        <ListItem>
                            Son Konum Güncelleme:{" "}
                            {serverTime ? moment(serverTime).format("DD.MM.YYYY / HH:mm") : "-"}
                        </ListItem>
                    </List>
                </CollapsibleContent>
            </Section>

            <Section>
                <CollapsibleHeader onClick={() => setIsOrderInfoOpen(!isOrderInfoOpen)}>
                    <CollapsibleTitle>Sipariş</CollapsibleTitle>
                    <CollapsibleIcon>
                        {isOrderInfoOpen ? <UpOutlined /> : <DownOutlined />}
                    </CollapsibleIcon>
                </CollapsibleHeader>
                <CollapsibleContent isOpen={isOrderInfoOpen}>
                    {delivery?.orders && delivery.orders.length > 0 ? (
                        <div>
                            <List>
                                <ListItem>{delivery?.company?.name}</ListItem>
                            </List>
                            <List>
                                {delivery.pickupInfos?.map(info => (
                                    <ListItem key={info._id}>{info.name}</ListItem>
                                ))}
                            </List>
                            <List>
                                {delivery.orders?.map(order => (
                                    <ListItem key={order._id}>
                                        Alıcı Adı / Fiş Numarası:{" "}
                                        {order.receiverName || order.receiptNumber}
                                    </ListItem>
                                ))}
                            </List>
                        </div>
                    ) : (
                        <NoData>Bu kurye için sipariş bulunamadı.</NoData>
                    )}
                </CollapsibleContent>
            </Section>
        </PopupContainer>
    );
};

export default CourierPopup;
